import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            精选内容策划，发现更多精彩影视作品
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200/50">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}